/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_NoneInputs */

const vi_camera_location_none = /** @type {(inputs: Camera_Location_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa gắn vào đâu`)
};

/**

* @param {Camera_Location_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_none = /** @type {((inputs?: Camera_Location_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_none(inputs)
});